import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";

/**
 * Libellés partagés pour les dates où une personne est déjà invitée.
 * Centralisés ici pour rester cohérents entre tous les sélecteurs de date.
 */
export const ALREADY_INVITED_TOOLTIP = "Cette personne est déjà invitée à cet événement par vous ou un autre membre du club";
export const ALREADY_INVITED_LEGEND = "Déjà invité(e) — réunion non sélectionnable";
export const ALREADY_INVITED_LEGEND_COLOR = "bg-dark-grey opacity-70";

/**
 * Clé locale "année-mois-jour" indépendante du fuseau et de l'heure, pour
 * comparer une date à un jour affiché dans le calendrier.
 */
function dayKey(year: number, month: number, day: number): string {
  return `${year}-${month}-${day}`;
}

/**
 * Construit l'ensemble des clés "année-mois-jour" à partir de dates ISO.
 * Les jours présents dans cet ensemble ne sont pas sélectionnables.
 */
export function buildAlreadyInvitedKeys(dates?: string[]): Set<string> {
  return new Set((dates ?? []).map(iso => {
    const d = new Date(iso);
    return dayKey(d.getFullYear(), d.getMonth(), d.getDate());
  }));
}

/**
 * Indique si le `day` (jour du mois, 1-based) du mois affiché `monthDate`
 * fait partie des dates déjà invitées.
 */
export function isDayAlreadyInvited(keys: Set<string>, monthDate: Date, day: number): boolean {
  return keys.has(dayKey(monthDate.getFullYear(), monthDate.getMonth(), day));
}

/**
 * Version mémoïsée de `buildAlreadyInvitedKeys`, à utiliser dans les composants
 * pour éviter de reconstruire l'ensemble à chaque rendu.
 */
export function useAlreadyInvitedKeys(dates) {
  const $ = _c(2);
  let t0;
  if ($[0] !== dates) {
    t0 = buildAlreadyInvitedKeys(dates);
    $[0] = dates;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}